import { render } from "./NewSidebar.vue?vue&type=template&id=8f48fa9c&scoped=true&ts=true"
import script from "./NewSidebar.vue?vue&type=script&lang=ts"
export * from "./NewSidebar.vue?vue&type=script&lang=ts"

import "./NewSidebar.vue?vue&type=style&index=0&id=8f48fa9c&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f48fa9c"]])

export default __exports__